'use strict';

angular.module('imagetrend.components')
    .controller('AlertModalController', ['$scope', '$uibModalInstance', 'message', '$sce', function ($scope, $uibModalInstance, message, $sce) {
        $scope.message = $sce.trustAsHtml(message);

        $scope.ok = function () {
            $uibModalInstance.close(true);
        }
    }])
;